import React from 'react';
import _ from 'lodash';
import {Loader} from '../../../components/Loader/Loader';
import cancelEvent from '../../../../services/mini/cancelEvent';
import { AnalyticsPopupTile } from '../AnalyticsPopupTile/AnalyticsPopupTile';
import { AnalyticsSimpleTile } from '../AnalyticsSimpleTile/AnalyticsSimpleTile';
import VirtualizedTable from './VirtualizedTable';
import { SortDirection } from 'react-virtualized';
import { AnalyticsSimpleTileCollapser } from '../AnalyticsSimpleTile/AnalyticsSimpleTileCollapser';

class ScriptLineCell extends React.Component {

    goToFile = (e) => {
        const { pattern, highlightLine, project } = this.props;
        highlightLine({
            project,
            scriptName: pattern.file,
            lineNumber: pattern.line
        });
        cancelEvent(e);
    }

    render() {
        const { pattern } = this.props;
        return <span>
            {pattern.file && <i
                className="icon icon-alan-stat-script-link script-link-icon"
                title={`${pattern.file}: ${pattern.line}`}
                onClick={this.goToLine} />}
        </span>;
    }
}

class AnalyticPatternTile extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            patterns: this.getPatterns(props),
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.report?.data?.patternsDataUpdateTs !== nextProps.report?.data?.patternsDataUpdateTs) {
            return true;
        }
        if (this.props.selectedPatternId !== nextProps.selectedPatternId) {
            return true;
        }
        if (this.props.selectedPatternHash !== nextProps.selectedPatternHash) {
            return true;
        }
        if (JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)) {
            return true;
        }
        return false;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ patterns: this.getPatterns(nextProps) });
    }

    getPatterns = (props) => {
        return props.report?.data?.patterns;
    }
    selectPattern = ({ rowData: patternData }) => {
        const { selectPattern, selectedPatternId } = this.props;
        const patternHash = patternData.patternHash;
        const pattern = patternData.pattern;
        const patternId = patternData.id;
        if (patternId !== selectedPatternId) {
            selectPattern(patternHash, patternId, pattern);
        } else {
            selectPattern();
        }
    }

    render() {
        const {
            environment,
            project,
            highlightLine,
            selectedPatternId
        } = this.props;

        const {
            patterns,
        } = this.state;

        return (
            <AnalyticsSimpleTile {...this.props}>
                <div className={`analytic-patterns-tile ${environment}`}>
                    <AnalyticsSimpleTileCollapser {...this.props}>
                        <div className="analytic-patterns-tile_header">
                            Patterns: <div className="analytic-patterns-tile_total">{(patterns && patterns.length > 0) ? `${patterns.length}` : '—'}</div>
                        </div>
                    </AnalyticsSimpleTileCollapser>
                    {patterns ?
                        <div className="analytic-patterns-tile_body">
                            {patterns.length > 0 ? <VirtualizedTable
                                className="analytics-table"
                                headerClassName="analytics-table_header-cell"
                                getRowClassName={(pattern) => {
                                    return `${(selectedPatternId === pattern?.id) && 'selected'}`;
                                }}
                                sortBy="matches"
                                width={575}
                                sortDirection={SortDirection.DESC}
                                onRowClick={this.selectPattern}
                                data={patterns}
                                columns={[
                                    {
                                        dataKey: 'pattern',
                                        colName: 'Pattern',
                                        sortable: true,
                                        className: 'semibold',
                                        width: 265,
                                    },
                                    {
                                        dataKey: 'matches',
                                        colName: 'Matches',
                                        sortable: true,
                                        width: 80,
                                        headerClassName: "to-right",
                                        className: "to-right"
                                    },
                                    {
                                        dataKey: 'score',
                                        colName: 'Min. / Avg. / Max. score',
                                        disableSort: true,
                                        width: 190,
                                        formatter: (pattern) => {
                                            return <React.Fragment>
                                                <span className="score">{Math.round(pattern.minScore * 1000) / 1000}</span>
                                                <span className="score">{Math.round(pattern.avgScore * 1000) / 1000}</span>
                                                <span className="score">{Math.round(pattern.maxScore * 1000) / 1000}</span>
                                            </React.Fragment>;
                                        },
                                        headerClassName: "to-right not-sortable",
                                        className: "to-right"
                                    },
                                    {
                                        dataKey: 'script-line',
                                        colName: '',
                                        sortable: false,
                                        disableSort: true,
                                        width: 40,
                                        formatter: (pattern) => {
                                            return <ScriptLineCell
                                                pattern={pattern}
                                                project={project}
                                                highlightLine={highlightLine}
                                            />;
                                        },
                                        headerClassName: "to-right not-sortable",
                                        className: "to-right"
                                    },

                                ]}
                            /> : <div className="analytic-patterns-tile_no-data">Not enough data to show this report.</div>}
                        </div> :
                        <Loader theme="dark" size="small" center={true} />}
                </div>
            </AnalyticsSimpleTile>
        );
    }
}


export default AnalyticsPopupTile(AnalyticPatternTile);
